import * as Routes from '../../scripts/routes';
import { notification } from 'antd';
import sortable from "html5sortable/dist/html5sortable.es"
import { createSpuTemplateEditor, insertSpuVariable, extractVariableKeysFromTemplateJson } from '../lib/spu_tiptap_template';

do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  FormularioPersonalizadoNewEditController = ($http, $scope, $timeout) ->
    vm = @

    # CONSTANTS
    vm.TIPOS_CAMPO = ['text', 'number', 'select', 'checkbox']

    # VARIABLES VIEW MODEL
    vm.assuntos        = []
    vm.loadingAssuntos = false

    vm.fields = []
    vm.form   = {ativo: true}
    vm.templateEditor = null
    vm.headerEditor = null
    vm.footerEditor = null
    vm.templateEditorReady = false
    vm.templateEditorLoading = true
    vm.templateJson = {type: 'doc', content: [{type: 'paragraph'}]}
    vm.templateJsonSerialized = JSON.stringify(vm.templateJson)
    vm.templateVariableInvalidKeys = []
    vm.templateUnusedFieldKeys = []
    vm.fieldVariablesList = []
    vm.activeToolbarGroup = 'editor'
    vm.editorZoom = 100
    vm.selectedBlockType = 'paragraph'
    vm.selectedFontSize = '16px'
    vm.selectedFontColor = '#1f2933'
    vm.tablePickerOpen = false
    vm.marginEditorOpen = false
    vm.pageNumberPickerOpen = false
    vm.variableMenuOpen = null
    vm.activeContentEditor = 'main'
    vm._pendingImageTargetEditor = 'main'
    vm.cursorInsideTable = false
    vm.canMergeTableCells = false
    vm.tablePickerRows = [1,2,3,4,5,6,7,8,9,10,11,12]
    vm.tablePickerCols = [1,2,3,4,5,6,7,8,9,10,11,12]
    vm.tableHoverRows = 0
    vm.tableHoverCols = 0
    vm.rulerWidthPx = 794
    vm.defaultPageMarginTopPx = Math.round((18.0 / 25.4) * 96)
    vm.defaultPageMarginRightPx = Math.round((18.0 / 25.4) * 96)
    vm.defaultPageMarginBottomPx = Math.round((18.0 / 25.4) * 96)
    vm.defaultPageMarginLeftPx = Math.round((18.0 / 25.4) * 96)
    vm.defaultHeaderHeightPx = 120
    vm.defaultFooterHeightPx = 120
    vm.maxHeaderHeightPx = 120
    vm.maxFooterHeightPx = 120
    vm.defaultPageNumberRightCm = 1.25
    vm.defaultPageNumberBottomCm = 1.0
    vm.minDocumentBodyHeightPx = 420
    vm.pageMarginTopPx = vm.defaultPageMarginTopPx
    vm.pageMarginRightPx = vm.defaultPageMarginRightPx
    vm.pageMarginBottomPx = vm.defaultPageMarginBottomPx
    vm.pageMarginLeftPx = vm.defaultPageMarginLeftPx
    vm.maxMarginHorizontalCm = 5
    vm.maxMarginVerticalCm = 8
    vm.maxMarginHorizontalPx = 0
    vm.maxMarginVerticalPx = 0
    vm.pageMarginTopCm = 0
    vm.pageMarginRightCm = 0
    vm.pageMarginBottomCm = 0
    vm.pageMarginLeftCm = 0
    vm.activeMarginSide = null
    vm.pageHeaderEnabled = false
    vm.pageFooterEnabled = false
    vm.pageHeaderHeightPx = vm.defaultHeaderHeightPx
    vm.pageFooterHeightPx = vm.defaultFooterHeightPx
    vm.pageHeaderContentJson = {type: 'doc', content: [{type: 'paragraph'}]}
    vm.pageFooterContentJson = {type: 'doc', content: [{type: 'paragraph'}]}
    vm.pageHeaderHtml = ''
    vm.pageFooterHtml = ''
    vm.pageHeaderHeightInput = String(vm.defaultHeaderHeightPx)
    vm.pageFooterHeightInput = String(vm.defaultFooterHeightPx)
    vm.pageHeaderHeightDraft = String(vm.defaultHeaderHeightPx)
    vm.pageFooterHeightDraft = String(vm.defaultFooterHeightPx)
    vm.pageSectionEditorMode = null
    vm.pageSectionOverlayStyles =
      header: {display: 'none'}
      footer: {display: 'none'}
    vm.activeHeaderPageNumber = 1
    vm.activeFooterPageNumber = 1
    vm.rulerPaddingLeftPx = vm.pageMarginLeftPx
    vm.rulerPaddingRightPx = vm.pageMarginRightPx
    vm.rulerMinPx = vm.rulerPaddingLeftPx
    vm.rulerMaxPx = vm.rulerWidthPx - vm.rulerPaddingRightPx
    vm.rulerCmTotal = 21
    vm.pageWidthPx = 794
    vm.pageHeightPx = 1123
    vm.pageGapPx = 32
    vm.renderPageHeightPx = vm.pageHeightPx
    vm.renderPageGapPx = vm.pageGapPx
    vm.editorPageCount = 1
    vm.editorPageIndexes = [0]
    vm.editorPageMetrics = [{top: 0, height: vm.pageHeightPx}]
    vm.editorPagesTotalHeightPx = vm.pageHeightPx
    vm.rulerPageMetrics = [{top: 0, height: vm.pageHeightPx}]
    vm.rulerPagesTotalHeightPx = vm.pageHeightPx
    vm.showPageNumbers = false
    vm.pageNumberRightCm = vm.defaultPageNumberRightCm
    vm.pageNumberBottomCm = vm.defaultPageNumberBottomCm
    vm.pageDebug =
      pageCount: 1
      contentPageHeight: 0
      naturalContentHeight: 0
      totalHeight: vm.pageHeightPx
      marginTop: vm.pageMarginTopPx
      marginBottom: vm.pageMarginBottomPx
      gap: vm.pageGapPx
      pageBreakExpected: vm.pageMarginTopPx + vm.pageMarginBottomPx + vm.pageGapPx
    vm.rulerLeftIndentPx = 0
    vm.rulerFirstLineIndentPx = 0
    vm.rulerDragging = null
    vm.rulerTickItems = []
    vm.rulerCmLabels = []
    vm._rulerMoveHandler = null
    vm._rulerUpHandler = null
    vm._rulerDownHandler = null
    vm._rulerLeftDownHandler = null
    vm._rulerFirstDownHandler = null
    vm._leftSliderInputHandler = null
    vm._firstSliderInputHandler = null
    vm._headerHeightInputHandler = null
    vm._footerHeightInputHandler = null
    vm._editorResizeObserver = null
    vm._updatingPaginationOptions = false
    vm._refreshEditorPagesTimeout = null
    vm._pendingPageSectionFocus = null
    vm._paginationDisabledByGuard = false
    vm._initialEditorRefreshScheduled = false
    vm.enableEditorPagination = true
    vm.PROCESSO_VARIABLES = [
      {key: 'processo_numero', label: 'Número do Processo', source: 'processo'}
      {key: 'processo_assunto_nome', label: 'Nome do Assunto', source: 'processo'}
      {key: 'processo_tipo_nome', label: 'Nome do Tipo', source: 'processo'}
    ]
    vm.MANIFESTANTE_VARIABLES = [
      {key: 'processo_manifestante_nome', label: 'Nome do Manifestante', source: 'manifestante'}
      {key: 'processo_manifestante_cpf_cnpj', label: 'CPF/CNPJ do Manifestante', source: 'manifestante'}
      {key: 'processo_manifestante_organizacao', label: 'Organização', source: 'manifestante'}
      {key: 'processo_manifestante_email', label: 'E-mail Principal', source: 'manifestante'}
      {key: 'processo_manifestante_nome_tipo_manifestante', label: 'Tipo de Usuário', source: 'manifestante'}
      {key: 'processo_manifestante_cep', label: 'CEP', source: 'manifestante'}
      {key: 'processo_manifestante_uf', label: 'Estado', source: 'manifestante'}
      {key: 'processo_manifestante_cidade', label: 'Cidade', source: 'manifestante'}
      {key: 'processo_manifestante_bairro', label: 'Bairro', source: 'manifestante'}
      {key: 'processo_manifestante_regional', label: 'Regional', source: 'manifestante'}
      {key: 'processo_manifestante_endereco', label: 'Endereço', source: 'manifestante'}
      {key: 'processo_manifestante_numero_endereco', label: 'Número do Endereço', source: 'manifestante'}
      {key: 'processo_manifestante_complemento', label: 'Complemento', source: 'manifestante'}
      {key: 'processo_manifestante_sexo', label: 'Sexo', source: 'manifestante'}
      {key: 'processo_manifestante_telefone_celular', label: 'Telefone Celular', source: 'manifestante'}
      {key: 'processo_manifestante_telefone_comercial', label: 'Telefone Comercial', source: 'manifestante'}
    ]
    vm.GENERAL_VARIABLES = [
      {key: 'data_atual', label: 'Data atual', source: 'general'}
    ]

    paginationDebug = (label, payload = {}) ->
      return

    waitForEditorPaint = ->
      new Promise((resolve) ->
        raf = window.requestAnimationFrame or ((callback) -> window.setTimeout(callback, 16))
        raf(-> raf(-> resolve()))
      )

    delay = (ms) ->
      new Promise((resolve) -> window.setTimeout(resolve, ms))

    setTemplateEditorLoading = (loading) ->
      vm.templateEditorLoading = !!loading
      $scope.$applyAsync()
      return

    # WATCHES
    $scope.$watch (->
      vm.form.tipo_id
    ), (current, _original) ->
      if current?
        id = current
        id = current.id if current?.id?
        setAssuntos(id)
      else
        vm.form.tipo_id    = null
        vm.form.assunto_id = null

    $scope.$watchCollection (->
      vm.fields
    ), (current, _original) ->
      if current.length > 1
        $timeout((->
          sortable('.sortable', {
            forcePlaceholderSize: true,
            placeholderClass:     'ph-class',
            hoverClass:           'bg-maroon yellow'
          })
        ), 200)
      vm.rebuildFieldVariables()
      vm.validateTemplateVariables()

    # INIT SETUP
    init = () =>
      $timeout((-> initFieldTypeSelect2()), 50)
      $timeout((-> initTemplateEditorWithRetry()), 50)
      $timeout((-> bindRulerDownEvent()), 80)
      $timeout((-> bindRulerHandleEvents()), 80)
      $timeout((-> bindRulerSliderEvents()), 90)
      $timeout((-> bindSectionHeightInputs()), 100)
      return

    updatePageLayoutVars = ->
      vm.rulerPaddingLeftPx = parseInt(vm.pageMarginLeftPx || 0, 10) || 0
      vm.rulerPaddingRightPx = parseInt(vm.pageMarginRightPx || 0, 10) || 0
      vm.rulerMinPx = vm.rulerPaddingLeftPx
      vm.rulerMaxPx = vm.rulerWidthPx - vm.rulerPaddingRightPx
      vm.rulerLeftIndentPx = clampRuler(vm.rulerLeftIndentPx || vm.rulerMinPx)
      vm.rulerFirstLineIndentPx = clampRuler(vm.rulerFirstLineIndentPx || vm.rulerMinPx)
      return

    maxMarginPxForSide = (side) ->
      if side == 'left' || side == 'right'
        vm.maxMarginHorizontalPx || Math.round((vm.maxMarginHorizontalCm / 2.54) * 96.0)
      else
        vm.maxMarginVerticalPx || Math.round((vm.maxMarginVerticalCm / 2.54) * 96.0)

    clampMarginPx = (value, fallback = 0, side = 'top') ->
      parsed = parseInt(value, 10)
      parsed = fallback if Number.isNaN(parsed)
      parsed = Math.max(0, parsed)
      Math.min(maxMarginPxForSide(side), parsed)

    pxToCm = (px) ->
      ((parseFloat(px || 0) * 2.54) / 96.0)

    cmToPx = (cm) ->
      ((parseFloat(cm || 0) / 2.54) * 96.0)

    safeFloat = (value, fallback = 0) ->
      parsed = parseFloat(value)
      if Number.isNaN(parsed) then fallback else parsed

    clampSectionHeightPx = (value, kind) ->
      parsed = parseInt(value, 10)
      if Number.isNaN(parsed)
        if kind == 'header'
          parsed = parseInt(vm.defaultHeaderHeightPx || 0, 10) || 0
        else
          parsed = parseInt(vm.defaultFooterHeightPx || 0, 10) || 0
      parsed = Math.max(0, parsed)
      maxAllowed = if kind == 'header' then vm.maxHeaderHeightPx else vm.maxFooterHeightPx
      parsed = Math.min(maxAllowed, parsed)

      totalMargins = (parseInt(vm.pageMarginTopPx || 0, 10) || 0) + (parseInt(vm.pageMarginBottomPx || 0, 10) || 0)
      otherHeight = if kind == 'header' then (if vm.pageFooterEnabled then parseInt(vm.pageFooterHeightPx || 0, 10) || 0 else 0) else (if vm.pageHeaderEnabled then parseInt(vm.pageHeaderHeightPx || 0, 10) || 0 else 0)
      pageHeight = parseInt(vm.pageHeightPx || 1123, 10) || 1123
      maxByPage = Math.max(0, pageHeight - totalMargins - otherHeight - vm.minDocumentBodyHeightPx)

      result = Math.min(parsed, maxByPage)
      if Number.isNaN(result)
        if kind == 'header'
          return parseInt(vm.defaultHeaderHeightPx || 0, 10) || 0
        return parseInt(vm.defaultFooterHeightPx || 0, 10) || 0
      result

    syncMarginCmFieldsFromPx = ->
      vm.pageMarginTopCm = parseFloat(pxToCm(vm.pageMarginTopPx).toFixed(2))
      vm.pageMarginRightCm = parseFloat(pxToCm(vm.pageMarginRightPx).toFixed(2))
      vm.pageMarginBottomCm = parseFloat(pxToCm(vm.pageMarginBottomPx).toFixed(2))
      vm.pageMarginLeftCm = parseFloat(pxToCm(vm.pageMarginLeftPx).toFixed(2))
      vm.maxMarginHorizontalPx = Math.round(cmToPx(vm.maxMarginHorizontalCm))
      vm.maxMarginVerticalPx = Math.round(cmToPx(vm.maxMarginVerticalCm))
      return

    ensureTemplateLayout = ->
      vm.templateJson = {} unless angular.isObject(vm.templateJson)
      vm.templateJson.type = 'doc' unless vm.templateJson.type?
      vm.templateJson.layout = {} unless angular.isObject(vm.templateJson.layout)
      vm.templateJson.layout.header = {} unless angular.isObject(vm.templateJson.layout.header)
      vm.templateJson.layout.footer = {} unless angular.isObject(vm.templateJson.layout.footer)
      vm.templateJson.layout

    mergeTemplateLayout = (sourceJson) ->
      merged = angular.copy(sourceJson || {type: 'doc', content: [{type: 'paragraph'}]})
      previousLayout = if angular.isObject(vm.templateJson?.layout) then angular.copy(vm.templateJson.layout) else null
      merged.type = 'doc' unless merged.type?
      if previousLayout?
        merged.layout = previousLayout
      merged

    syncTemplateLayoutMetadata = ->
      layout = ensureTemplateLayout()
      layout.page_width_px = parseInt(vm.pageWidthPx || 794, 10) || 794
      layout.page_height_px = parseInt(vm.pageHeightPx || 1123, 10) || 1123
      layout.page_gap_px = parseInt(vm.pageGapPx || 32, 10) || 32
      layout.margin_top_px = parseInt(vm.pageMarginTopPx || 0, 10) || 0
      layout.margin_right_px = parseInt(vm.pageMarginRightPx || 0, 10) || 0
      layout.margin_bottom_px = parseInt(vm.pageMarginBottomPx || 0, 10) || 0
      layout.margin_left_px = parseInt(vm.pageMarginLeftPx || 0, 10) || 0
      layout.show_page_numbers = !!vm.showPageNumbers
      layout.page_number_right_cm = safeFloat(vm.pageNumberRightCm, vm.defaultPageNumberRightCm)
      layout.page_number_bottom_cm = safeFloat(vm.pageNumberBottomCm, vm.defaultPageNumberBottomCm)
      layout.header.enabled = !!vm.pageHeaderEnabled
      layout.header.height_px = parseInt(vm.pageHeaderHeightPx || 0, 10) || 0
      layout.header.content_json = vm.pageHeaderContentJson || {type: 'doc', content: [{type: 'paragraph'}]}
      layout.footer.enabled = !!vm.pageFooterEnabled
      layout.footer.height_px = parseInt(vm.pageFooterHeightPx || 0, 10) || 0
      layout.footer.content_json = vm.pageFooterContentJson || {type: 'doc', content: [{type: 'paragraph'}]}
      vm.templateJsonSerialized = JSON.stringify(vm.templateJson || {type: 'doc', content: [{type: 'paragraph'}]})
      return

    forceTemplatePaginationRefresh = ->
      return unless vm.templateEditor?.view? && vm.templateEditor?.state?
      refreshTransaction = vm.templateEditor.state.tr.setMeta('fpTemplateLayoutRefresh', Date.now())
      vm.templateEditor.view.dispatch(refreshTransaction)
      return

    buildSectionHtml = (rawHtml, heightPx, kind) ->
      resolvedHeightPx = Math.max(0, parseInt(heightPx || 0, 10) || 0)
      contentHtml = String(rawHtml || '')
      sectionClass = if kind == 'footer' then 'fp-page-section-rendered fp-page-section-rendered-footer' else 'fp-page-section-rendered fp-page-section-rendered-header'
      "<div class=\"#{sectionClass}\" style=\"display: block; min-height: #{resolvedHeightPx}px; max-height: #{resolvedHeightPx}px; overflow: hidden;\">#{contentHtml}</div>"

    targetPageSectionSelector = (kind, pageNumber = 1) ->
      normalizedPageNumber = Math.max(1, parseInt(pageNumber || 1, 10) || 1)
      if kind == 'footer'
        "#pages > .rm-page-break:nth-child(#{normalizedPageNumber}) .rm-page-footer-content"
      else if normalizedPageNumber <= 1
        '.rm-first-page-header .rm-page-header-content'
      else
        "#pages > .rm-page-break:nth-child(#{normalizedPageNumber - 1}) .rm-page-header-content"

    updatePageSectionOverlay = (kind, pageNumber = 1) ->
      stack = document.querySelector('.fp-editor-pages-stack')
      hostEditor = document.getElementById('fp_template_editor')
      normalizedPageNumber = Math.max(1, parseInt(pageNumber || 1, 10) || 1)
      unless stack? && hostEditor?
        vm.pageSectionOverlayStyles[kind] = {display: 'none'}
        return

      selector = targetPageSectionSelector(kind, pageNumber)
      sectionNode = hostEditor.querySelector(selector)
      unless sectionNode?
        vm.pageSectionOverlayStyles[kind] = {display: 'none'}
        return

      stackRect = stack.getBoundingClientRect()
      sectionRect = sectionNode.getBoundingClientRect()
      hostStyles = window.getComputedStyle(hostEditor)
      leftInset = parseFloat(hostStyles?.getPropertyValue('--rm-margin-left') || '0') || 0
      rightInset = parseFloat(hostStyles?.getPropertyValue('--rm-margin-right') || '0') || 0
      overlayWidth = parseInt(Math.round(sectionRect.width || 0), 10) || 0
      overlayHeight = parseInt(Math.round(sectionRect.height || 0), 10) || 0

      if kind == 'footer'
        footerRoot = sectionNode.closest('.rm-page-footer')
        footerLeftNode = sectionNode.querySelector('.rm-page-footer-left')
        footerRightNode = sectionNode.querySelector('.rm-page-footer-right')
        footerRootStyles = window.getComputedStyle(footerRoot) if footerRoot?
        footerLeftStyles = window.getComputedStyle(footerLeftNode) if footerLeftNode?
        footerRightStyles = window.getComputedStyle(footerRightNode) if footerRightNode?
        footerContentStyles = window.getComputedStyle(sectionNode) if sectionNode?
      else if kind == 'header' && normalizedPageNumber == 1
        headerRoot = sectionNode.closest('.rm-first-page-header')
        headerLeftNode = sectionNode.querySelector('.rm-page-header-left')
        headerRightNode = sectionNode.querySelector('.rm-page-header-right')
        headerRootStyles = window.getComputedStyle(headerRoot) if headerRoot?
        headerContentStyles = window.getComputedStyle(sectionNode) if sectionNode?
        headerLeftStyles = window.getComputedStyle(headerLeftNode) if headerLeftNode?
        headerRightStyles = window.getComputedStyle(headerRightNode) if headerRightNode?

      if overlayWidth <= 0 || overlayHeight <= 0
        vm.pageSectionOverlayStyles[kind] = {display: 'none'}
        return

      overlayStyles =
        display: 'block'
        top: "#{Math.max(0, Math.round(sectionRect.top - stackRect.top))}px"
        left: "#{Math.max(0, Math.round(sectionRect.left - stackRect.left))}px"
        width: "#{overlayWidth}px"
        height: "#{overlayHeight}px"

      if kind == 'header' && normalizedPageNumber > 1
        overlayStyles.boxSizing = 'border-box'
        overlayStyles.paddingLeft = "#{parseInt(vm.pageMarginLeftPx || 0, 10) || 0}px"
        overlayStyles.paddingRight = "#{parseInt(vm.pageMarginRightPx || 0, 10) || 0}px"

      vm.pageSectionOverlayStyles[kind] = overlayStyles
      return

    refreshPageSectionOverlays = ->
      if vm.pageHeaderEnabled && vm.pageSectionEditorMode == 'header'
        updatePageSectionOverlay('header', vm.activeHeaderPageNumber)
      else
        vm.pageSectionOverlayStyles.header = {display: 'none'}

      if vm.pageFooterEnabled && vm.pageSectionEditorMode == 'footer'
        updatePageSectionOverlay('footer', vm.activeFooterPageNumber)
      else
        vm.pageSectionOverlayStyles.footer = {display: 'none'}
      return

    flushPendingPageSectionFocus = ->
      pending = vm._pendingPageSectionFocus
      return unless pending?
      vm._pendingPageSectionFocus = null
      if pending.section == 'header'
        vm.focusHeaderSection(pending.pageNumber)
      else if pending.section == 'footer'
        vm.focusFooterSection(pending.pageNumber)
      return

    resolveSectionHeightInputPx = (kind) ->
      draftValue = if kind == 'footer' then vm.pageFooterHeightDraft else vm.pageHeaderHeightDraft
      parsedDraftValue = parseInt(draftValue, 10)
      return parsedDraftValue unless Number.isNaN(parsedDraftValue)

      modelValue = if kind == 'footer' then vm.pageFooterHeightInput else vm.pageHeaderHeightInput
      parsedModelValue = parseInt(modelValue, 10)
      return parsedModelValue unless Number.isNaN(parsedModelValue)

      elementId = if kind == 'footer' then 'fp_page_footer_height_input' else 'fp_page_header_height_input'
      rawElementValue = document.getElementById(elementId)?.value
      parsedElementValue = parseInt(rawElementValue, 10)
      return parsedElementValue unless Number.isNaN(parsedElementValue)

      if kind == 'footer' then vm.pageFooterHeightPx else vm.pageHeaderHeightPx

    syncSectionHeightInputs = ->
      vm.pageHeaderHeightInput = String(parseInt(vm.pageHeaderHeightPx || 0, 10) || 0)
      vm.pageFooterHeightInput = String(parseInt(vm.pageFooterHeightPx || 0, 10) || 0)
      vm.pageHeaderHeightDraft = vm.pageHeaderHeightInput
      vm.pageFooterHeightDraft = vm.pageFooterHeightInput
      headerInput = document.getElementById('fp_page_header_height_input')
      footerInput = document.getElementById('fp_page_footer_height_input')
      headerInput.value = vm.pageHeaderHeightInput if headerInput?
      footerInput.value = vm.pageFooterHeightInput if footerInput?
      return

    rebuildRulerPageMetrics = (pageContentNodes = null) ->
      pageCount = parseInt(vm.editorPageCount || 1, 10) || 1
      pageHeight = parseInt(vm.renderPageHeightPx || vm.pageHeightPx || 1123, 10) || 1123
      hasMeasuredPages = pageContentNodes? && pageContentNodes.length == pageCount

      if hasMeasuredPages
        baseTop = parseInt(pageContentNodes[0]?.offsetTop || 0, 10) || 0
        pageTopList = pageContentNodes.map((node) ->
          nodeTopRaw = parseInt(node?.offsetTop || 0, 10) || 0
          Math.max(0, nodeTopRaw - baseTop)
        )

        vm.rulerPageMetrics = pageTopList.map((pageTop, pageIndex) ->
          top: pageTop
          height: pageHeight
        )
        lastMetric = vm.rulerPageMetrics[vm.rulerPageMetrics.length - 1]
        vm.rulerPagesTotalHeightPx = (lastMetric?.top || 0) + pageHeight
      else
        interPageSpace = parseInt(vm.renderPageGapPx || vm.pageGapPx || 0, 10) || 0
        vm.rulerPageMetrics = [0...pageCount].map((pageIndex) ->
          top: pageIndex * (pageHeight + interPageSpace)
          height: pageHeight
        )
        vm.rulerPagesTotalHeightPx = (pageCount * pageHeight) + ((pageCount - 1) * interPageSpace)
      return

    applyEditorLayoutStyles = ->
      return unless vm.templateEditor?
      return unless vm.enableEditorPagination
      return if vm._updatingPaginationOptions
      vm._updatingPaginationOptions = true
      headerHeightPx = if vm.pageHeaderEnabled then parseInt(vm.pageHeaderHeightPx || 0, 10) || 0 else 0
      footerHeightPx = if vm.pageFooterEnabled then parseInt(vm.pageFooterHeightPx || 0, 10) || 0 else 0
      try
        paginationStorage = vm.templateEditor?.storage?.PaginationPlus
        if paginationStorage?
          paginationStorage.headerHeight = new Map([[0, headerHeightPx]])
          paginationStorage.footerHeight = new Map([[0, footerHeightPx]])
        vm.templateEditor.commands.updatePageHeight(vm.pageHeightPx)
        vm.templateEditor.commands.updatePageWidth(vm.pageWidthPx)
        vm.templateEditor.commands.updatePageGap(vm.pageGapPx)
        vm.templateEditor.commands.updateMargins({
          top: vm.pageMarginTopPx
          bottom: vm.pageMarginBottomPx
          left: vm.pageMarginLeftPx
          right: vm.pageMarginRightPx
        })
        vm.templateEditor.commands.updateContentMargins({
          top: 0
          bottom: 0
        })
        headerHtml = if vm.pageHeaderEnabled then buildSectionHtml(vm.pageHeaderHtml, headerHeightPx, 'header') else ''
        footerHtml = if vm.pageFooterEnabled then buildSectionHtml(vm.pageFooterHtml, footerHeightPx, 'footer') else ''
        pageNumberRightCm = safeFloat(vm.pageNumberRightCm, vm.defaultPageNumberRightCm)
        pageNumberBottomCm = safeFloat(vm.pageNumberBottomCm, vm.defaultPageNumberBottomCm)
        footerRight = if vm.showPageNumbers then "<span class=\"fp-page-number\" style=\"margin-right: #{pageNumberRightCm}cm; margin-bottom: #{pageNumberBottomCm}cm;\">{page}</span>" else ''
        vm.templateEditor.commands.updateHeaderContent(headerHtml, '')
        vm.templateEditor.commands.updateFooterContent(footerHtml, footerRight)
      finally
        vm._updatingPaginationOptions = false
      forceTemplatePaginationRefresh()
      $timeout((-> refreshPageSectionOverlays()), 0)
      syncTemplateLayoutMetadata()
      return

    currentFormattingEditor = ->
      if vm.activeContentEditor == 'header' && vm.headerEditor?
        return vm.headerEditor
      if vm.activeContentEditor == 'footer' && vm.footerEditor?
        return vm.footerEditor
      vm.templateEditor

    currentFormattingEditorSupportsBlocks = ->
      vm.activeContentEditor == 'main'

    currentImageTargetEditor = (section = vm._pendingImageTargetEditor || vm.activeContentEditor || 'main') ->
      if section == 'header' && vm.headerEditor?
        return vm.headerEditor
      if section == 'footer' && vm.footerEditor?
        return vm.footerEditor
      vm.templateEditor

    currentImageTargetSection = ->
      vm._pendingImageTargetEditor || vm.activeContentEditor || 'main'

    ensureTrailingParagraphAfterImage = (editor) ->
      doc = editor?.state?.doc
      lastNode = doc?.lastChild
      return unless lastNode?
      return unless lastNode.type?.name == 'image' || lastNode.type?.name == 'resizableImage'

      endPos = doc.content.size
      editor.commands.insertContentAt(endPos, {type: 'paragraph'})
      return

    resizeImageIfNeeded = (file, dataUrl, maxHeightPx = null) ->
      return Promise.resolve({src: dataUrl, alt: file?.name || ''}) unless maxHeightPx? && maxHeightPx > 0

      new Promise((resolve) ->
        img = new window.Image()
        img.onload = ->
          naturalWidth = parseInt(img.naturalWidth || img.width || 0, 10) || 0
          naturalHeight = parseInt(img.naturalHeight || img.height || 0, 10) || 0
          if naturalWidth <= 0 || naturalHeight <= 0
            resolve({src: dataUrl, alt: file?.name || ''})
            return

          scale = Math.min(1, maxHeightPx / naturalHeight)
          nextWidth = Math.max(1, Math.round(naturalWidth * scale))
          nextHeight = Math.max(1, Math.round(naturalHeight * scale))
          resolve({
            src: dataUrl
            alt: file?.name || ''
            width: nextWidth
            height: nextHeight
            style: "display: block; width: #{nextWidth}px; height: auto; cursor: pointer;"
          })
        img.onerror = ->
          resolve({src: dataUrl, alt: file?.name || ''})
        img.src = dataUrl
      )

    scheduleInitialEditorRefresh = ->
      return if vm._initialEditorRefreshScheduled
      return unless vm.templateEditor?

      vm._initialEditorRefreshScheduled = true
      setTemplateEditorLoading(true)

      fontsReady =
        if document?.fonts?.ready
          document.fonts.ready.catch(-> null)
        else
          Promise.resolve()

      fontsReady
        .then(-> waitForEditorPaint())
        .catch(-> null)
        .then(->
          return unless vm.templateEditor?
          refreshEditorPages()
        )
        .then(->
          return unless vm.templateEditor?
          vm.templateEditor.view.focus?()
          waitForEditorPaint()
        )
        .then(->
          return unless vm.templateEditor?
          refreshEditorPages()
        )
        .then(->
          return unless vm.templateEditor?
          delay(80)
        )
        .then(->
          return unless vm.templateEditor?
          refreshEditorPages()
        )
        .then(->
          return unless vm.templateEditor?
          waitForEditorPaint()
        )
        .then(->
          return unless vm.templateEditor?
          if window.ResizeObserver? && !vm._editorResizeObserver?
            vm._editorResizeObserver = new ResizeObserver( ->
              refreshEditorPages()
            )
            vm._editorResizeObserver.observe(vm.templateEditor.view.dom)

          vm.syncRulerFromSelection()
          vm.validateTemplateVariables()
          setTemplateEditorLoading(false)
          return
        )
        .catch(->
          setTemplateEditorLoading(false)
          return
        )
      return

    applyEditorMinHeight = (editorDom, heightPx) ->
      nextHeight = Math.max(0, parseInt(heightPx || 0, 10) || 0)
      if nextHeight > 0
        editorDom.style.setProperty('min-height', "#{nextHeight}px", 'important')
      else
        editorDom.style.removeProperty('min-height')
      return

    refreshEditorPages = ->
      return if vm._updatingPaginationOptions
      if vm._refreshEditorPagesTimeout?
        $timeout.cancel(vm._refreshEditorPagesTimeout)
      vm._refreshEditorPagesTimeout = $timeout((->
        vm._refreshEditorPagesTimeout = null
        return if vm._updatingPaginationOptions
        editorDom = vm.templateEditor?.view?.dom
        return unless editorDom?
        paginationDebug('refresh:start',
          enabled: !!vm.enableEditorPagination
          scrollHeight: parseInt(editorDom.scrollHeight || 0, 10) || 0
          childCount: editorDom.childElementCount || 0
          htmlLength: editorDom.innerHTML?.length || 0
        )

        unless vm.enableEditorPagination
          pageHeight = vm.pageHeightPx || 1123
          vm.renderPageHeightPx = pageHeight
          vm.renderPageGapPx = 0
          vm.editorPageCount = 1
          vm.editorPageIndexes = [0]
          vm.editorPageMetrics = [{top: 0, height: pageHeight}]
          vm.editorPagesTotalHeightPx = pageHeight
          rebuildRulerPageMetrics()
          vm.pageDebug =
            pageCount: 1
            contentPageHeight: parseInt(Math.round(pageHeight - vm.pageMarginTopPx - vm.pageMarginBottomPx), 10) || 0
            naturalContentHeight: parseInt(Math.round(editorDom.scrollHeight || 0), 10) || 0
            totalHeight: parseInt(Math.round(pageHeight), 10) || pageHeight
            marginTop: parseInt(vm.pageMarginTopPx || 0, 10) || 0
            marginBottom: parseInt(vm.pageMarginBottomPx || 0, 10) || 0
            gap: 0
            pageBreakExpected: 0
          applyEditorMinHeight(editorDom, pageHeight)
          $scope.$applyAsync()
          refreshPageSectionOverlays()
          flushPendingPageSectionFocus()
          paginationDebug('refresh:disabled', vm.pageDebug)
          return

        pageHeight = vm.pageHeightPx || 1123
        gap = vm.pageGapPx || 20
        hostEditor = document.getElementById('fp_template_editor')
        pageNodes = []
        pageGapNodes = []
        pageContentNodes = []
        if hostEditor? && hostEditor.querySelectorAll?
          pageNodes = Array.from(hostEditor.querySelectorAll('.rm-page-break'))
          pageGapNodes = Array.from(hostEditor.querySelectorAll('.rm-pagination-gap'))
          pageContentNodes = Array.from(hostEditor.querySelectorAll('.rm-page-break > .page'))
        else
          pageNodes = Array.from(editorDom.querySelectorAll('.rm-page-break'))
          pageGapNodes = Array.from(editorDom.querySelectorAll('.rm-pagination-gap'))
          pageContentNodes = Array.from(editorDom.querySelectorAll('.rm-page-break > .page'))
        cssVars = window.getComputedStyle(editorDom)
        cssPageHeight = parseFloat(cssVars?.getPropertyValue('--rm-page-height') || '')
        measuredPageHeight = parseInt(Math.round(cssPageHeight), 10) || pageHeight
        measuredGap = gap
        measuredMetrics = []

        if pageNodes.length > 0
          baseTop = parseInt(pageNodes[0].offsetTop || 0, 10) || 0

          for node, idx in pageNodes
            nodeTopRaw = parseInt(node?.offsetTop || 0, 10) || 0
            nodeTop = Math.max(0, nodeTopRaw - baseTop)

            breakerNode = null
            for child in Array.from(node?.children || [])
              if child?.classList?.contains('breaker')
                breakerNode = child
                break

            gapNode = null
            gapNode = breakerNode.querySelector('.rm-pagination-gap') if breakerNode? && breakerNode.querySelector?
            gapHeight = parseInt(Math.round(gapNode?.offsetHeight || 0), 10) || 0
            measuredGap = gapHeight if gapHeight > 0

            nextNode = pageNodes[idx + 1]
            nextTopRaw = parseInt(nextNode?.offsetTop || 0, 10) || 0
            nextTop = Math.max(0, nextTopRaw - baseTop)

            pageHeightPx = measuredPageHeight
            if nextNode?
              stride = Math.max(0, nextTop - nodeTop)
              pageHeightPx = Math.max(0, stride - measuredGap) if stride > 0
            else if breakerNode?
              pageHeightPx = parseInt(Math.round(breakerNode.offsetTop || measuredPageHeight), 10) || measuredPageHeight

            pageHeightPx = measuredPageHeight if pageHeightPx <= 0
            measuredMetrics.push({top: nodeTop, height: pageHeightPx})

        maxSafePages = 120
        pageCountByBreaks = pageNodes.length
        pageCountByGaps = pageGapNodes.length
        pageCountByPages = pageContentNodes.length
        pageStride = Math.max(1, measuredPageHeight + measuredGap)
        pageCountByHeight = parseInt(Math.round((editorDom.scrollHeight + measuredGap) / pageStride), 10) || 1
        imageCount = if editorDom.querySelectorAll? then editorDom.querySelectorAll('img').length else 0
        pageCount = Math.max(pageCountByBreaks, pageCountByGaps, pageCountByPages, pageCountByHeight, 1)
        paginationDebug('refresh:measured',
          pageCountByBreaks: pageCountByBreaks
          pageCountByGaps: pageCountByGaps
          pageCountByPages: pageCountByPages
          pageCountByHeight: pageCountByHeight
          pageCount: pageCount
          measuredPageHeight: measuredPageHeight
          measuredGap: measuredGap
          scrollHeight: parseInt(editorDom.scrollHeight || 0, 10) || 0
          pageNodes: pageNodes.length
          pageContentNodes: pageContentNodes.length
          imageCount: imageCount
        )

        if pageCount > maxSafePages && !vm._paginationDisabledByGuard
          vm._updatingPaginationOptions = true
          try
            if vm.templateEditor?.commands?.disablePagination?
              vm.templateEditor.commands.disablePagination()
          finally
            vm._updatingPaginationOptions = false

          vm._paginationDisabledByGuard = true
          pageCount = 1
          vm.renderPageHeightPx = pageHeight
          vm.renderPageGapPx = parseInt(vm.pageGapPx || 0, 10) || 0
          vm.editorPageCount = pageCount
          vm.editorPageIndexes = [0]
          vm.editorPageMetrics = [{top: 0, height: pageHeight}]
          vm.editorPagesTotalHeightPx = pageHeight
          rebuildRulerPageMetrics(pageContentNodes)
          vm.pageDebug =
            pageCount: 1
            contentPageHeight: parseInt(Math.round(pageHeight - vm.pageMarginTopPx - vm.pageMarginBottomPx), 10) || 0
            naturalContentHeight: parseInt(Math.round(editorDom.scrollHeight || 0), 10) || 0
            totalHeight: parseInt(Math.round(pageHeight), 10) || pageHeight
            marginTop: parseInt(vm.pageMarginTopPx || 0, 10) || 0
            marginBottom: parseInt(vm.pageMarginBottomPx || 0, 10) || 0
            gap: parseInt(vm.pageGapPx || 0, 10) || 0
            pageBreakExpected: (parseInt(vm.pageMarginTopPx || 0, 10) || 0) + (parseInt(vm.pageMarginBottomPx || 0, 10) || 0) + (parseInt(vm.pageGapPx || 0, 10) || 0)
          applyEditorMinHeight(editorDom, pageHeight)
          $scope.$applyAsync()
          refreshPageSectionOverlays()
          flushPendingPageSectionFocus()
          paginationDebug('refresh:guard-disabled', vm.pageDebug)
          return

        vm.editorPageCount = pageCount
        vm.renderPageHeightPx = measuredPageHeight
        vm.renderPageGapPx = measuredGap
        vm.editorPageIndexes = [0...pageCount]
        vm.editorPageMetrics = vm.editorPageIndexes.map((pageIndex) ->
          top: pageIndex * (measuredPageHeight + measuredGap)
          height: measuredPageHeight
        )
        vm.editorPagesTotalHeightPx = (pageCount * measuredPageHeight) + ((pageCount - 1) * measuredGap)
        rebuildRulerPageMetrics(pageContentNodes)
        vm.pageDebug =
          pageCount: parseInt(pageCount || 1, 10) || 1
          contentPageHeight: parseInt(Math.round(pageHeight - vm.pageMarginTopPx - vm.pageMarginBottomPx), 10) || 0
          naturalContentHeight: parseInt(Math.round(editorDom.scrollHeight || 0), 10) || 0
          totalHeight: parseInt(Math.round(vm.editorPagesTotalHeightPx || pageHeight), 10) || pageHeight
          marginTop: parseInt(vm.pageMarginTopPx || 0, 10) || 0
          marginBottom: parseInt(vm.pageMarginBottomPx || 0, 10) || 0
          gap: parseInt(vm.renderPageGapPx || 0, 10) || 0
          pageBreakExpected: (parseInt(vm.pageMarginTopPx || 0, 10) || 0) + (parseInt(vm.pageMarginBottomPx || 0, 10) || 0) + (parseInt(vm.pageGapPx || 0, 10) || 0)

        applyEditorMinHeight(editorDom, vm.editorPagesTotalHeightPx || pageHeight)
        $scope.$applyAsync()
        refreshPageSectionOverlays()
        flushPendingPageSectionFocus()
        paginationDebug('refresh:done', vm.pageDebug)
      ), 16)
      return

    # METHODS PRIVATE
    initFieldTypeSelect2 = ->
      $timeout((->
        $els = $('.fp-field-type')
        return unless $els.length > 0
        $els.each ->
          $el = $(this)
          $el.select2('destroy') if $el.hasClass('select2-hidden-accessible')
          $el.select2({width: '100%'})
      ), 0)
      return

    setAssuntos = (tipo_id) ->
      if tipo_id? && tipo_id != ""
        vm.loadingAssuntos = true
        vm.assuntos        = [{nome: 'CARREGANDO...'}]
        $http.get(Routes.assuntos_processos_path(tipo_id), {cache: true}).then ((result) ->
          if(result.status == 200)
            vm.assuntos = result.data
            vm.form.assunto_id = {id: vm.form.assunto_id} if vm.form?.assunto_id
          else
            notification.warning({
              message:     'Atenção',
              description: 'Não foi possível processar o pedido.',
              duration:    10,
              placement:   'bottomRight'
            })
          vm.loadingAssuntos = false
        ), (error) ->
          vm.loadingAssuntos = false
          notification.error({
            message:     'Erro',
            description: error.data.message,
            duration:    10,
            placement:   'bottomRight'
          })
      return

    initTemplateEditorWithRetry = (attempt = 0) ->
      return if vm.templateEditorReady
      initialized = initTemplateEditor()
      initHeaderFooterEditors()
      bindRulerDownEvent()
      bindRulerHandleEvents()
      bindRulerSliderEvents()
      return if initialized
      return if attempt >= 8
      $timeout((-> initTemplateEditorWithRetry(attempt + 1)), 120)
      return

    bindRulerDownEvent = ->
      ruler = document.getElementById('fp_ruler')
      return unless ruler?
      return if vm._rulerDownHandler?

      vm._rulerDownHandler = (event) ->
        return if event?.target?.classList?.contains('fp-ruler-slider')
        x = eventClientX(event)
        rect = ruler.getBoundingClientRect()
        zoom = (parseInt(vm.editorZoom || 100, 10) || 100) / 100.0
        zoom = 1 if zoom <= 0
        localX = clampRuler((x - rect.left) / zoom)

        distLeft = Math.abs(localX - vm.rulerLeftIndentPx)
        distFirst = Math.abs(localX - vm.rulerFirstLineIndentPx)
        threshold = 14

        if distLeft <= threshold || distFirst <= threshold
          kind = if distLeft <= distFirst then 'left' else 'first'
          vm.startRulerDrag(kind, event)
          $scope.$applyAsync()
      ruler.addEventListener('mousedown', vm._rulerDownHandler)
      return

    bindRulerHandleEvents = ->
      leftHandle = document.getElementById('fp_ruler_handle_left')
      firstHandle = document.getElementById('fp_ruler_handle_first')

      if leftHandle? && !vm._rulerLeftDownHandler?
        vm._rulerLeftDownHandler = (event) ->
          vm.startLeftRulerDrag(event)
          $scope.$applyAsync()
        leftHandle.addEventListener('mousedown', vm._rulerLeftDownHandler)

      if firstHandle? && !vm._rulerFirstDownHandler?
        vm._rulerFirstDownHandler = (event) ->
          vm.startFirstRulerDrag(event)
          $scope.$applyAsync()
        firstHandle.addEventListener('mousedown', vm._rulerFirstDownHandler)
      return

    bindRulerSliderEvents = ->
      leftSlider = document.getElementById('fp_ruler_slider_left')
      firstSlider = document.getElementById('fp_ruler_slider_first')

      if leftSlider? && !vm._leftSliderInputHandler?
        vm._leftSliderInputHandler = (event) ->
          vm.rulerLeftIndentPx = parseInt(event?.target?.value || vm.rulerMinPx, 10) || vm.rulerMinPx
          vm.onLeftIndentSliderChange()
          $scope.$applyAsync()
        leftSlider.addEventListener('input', vm._leftSliderInputHandler)

      if firstSlider? && !vm._firstSliderInputHandler?
        vm._firstSliderInputHandler = (event) ->
          vm.rulerFirstLineIndentPx = parseInt(event?.target?.value || vm.rulerMinPx, 10) || vm.rulerMinPx
          vm.onFirstIndentSliderChange()
          $scope.$applyAsync()
        firstSlider.addEventListener('input', vm._firstSliderInputHandler)
      return

    syncSliderElements = ->
      leftSlider = document.getElementById('fp_ruler_slider_left')
      firstSlider = document.getElementById('fp_ruler_slider_first')
      leftSlider.value = String(vm.rulerLeftIndentPx) if leftSlider?
      firstSlider.value = String(vm.rulerFirstLineIndentPx) if firstSlider?
      return

    bindSectionHeightInputs = ->
      headerInput = document.getElementById('fp_page_header_height_input')
      footerInput = document.getElementById('fp_page_footer_height_input')

      if headerInput? && !vm._headerHeightInputHandler?
        vm._headerHeightInputHandler = (event) ->
          vm.pageHeaderHeightDraft = String(event?.target?.value || '')
        headerInput.addEventListener('input', vm._headerHeightInputHandler)
        headerInput.addEventListener('change', vm._headerHeightInputHandler)

      if footerInput? && !vm._footerHeightInputHandler?
        vm._footerHeightInputHandler = (event) ->
          vm.pageFooterHeightDraft = String(event?.target?.value || '')
        footerInput.addEventListener('input', vm._footerHeightInputHandler)
        footerInput.addEventListener('change', vm._footerHeightInputHandler)
      return

    initTemplateEditor = ->
      return true if vm.templateEditor?
      el = document.getElementById('fp_template_editor')
      return false unless el?

      try
        vm.templateEditor = createSpuTemplateEditor({
          element: el
          content: vm.templateJson
          placeholder: 'Escreva o texto do template e use as variáveis da barra superior.'
          enablePagination: vm.enableEditorPagination
          pageMetrics:
            pageHeightPx: vm.pageHeightPx
            pageWidthPx: vm.pageWidthPx
            pageGapPx: vm.pageGapPx
            marginTopPx: vm.pageMarginTopPx
            marginBottomPx: vm.pageMarginBottomPx
            marginLeftPx: vm.pageMarginLeftPx
            marginRightPx: vm.pageMarginRightPx
            contentMarginTopPx: 0
            contentMarginBottomPx: 0
            headerLeft: if vm.pageHeaderEnabled then buildSectionHtml(vm.pageHeaderHtml, vm.pageHeaderHeightPx, 'header') else ''
            footerLeft: if vm.pageFooterEnabled then buildSectionHtml(vm.pageFooterHtml, vm.pageFooterHeightPx, 'footer') else ''
            footerRight: if vm.showPageNumbers then '<span class="fp-page-number">{page}</span>' else ''
          onHeaderClick: (params) ->
            return unless vm.pageHeaderEnabled
            vm.focusHeaderSection(parseInt(params?.pageNumber || 1, 10) || 1)
            $scope.$applyAsync()
          onFooterClick: (params) ->
            return unless vm.pageFooterEnabled
            vm.focusFooterSection(parseInt(params?.pageNumber || 1, 10) || 1)
            $scope.$applyAsync()
          onFocus: ->
            vm.activeContentEditor = 'main'
            vm.pageSectionEditorMode = null
            refreshPageSectionOverlays()
            $scope.$applyAsync()
          onUpdate: (json) ->
            vm.templateJson = mergeTemplateLayout(json)
            vm.updateTableSelectionState(vm.templateEditor)
            return if vm._updatingPaginationOptions
            syncTemplateLayoutMetadata()
            vm.validateTemplateVariables()
            serializedJson = JSON.stringify(json || {})
            paginationDebug('editor:onUpdate',
              hasImage: serializedJson.indexOf('"type":"image"') >= 0 || serializedJson.indexOf('"type":"resizableImage"') >= 0
              contentLength: serializedJson.length
            )
            refreshEditorPages()
            $scope.$applyAsync()
          onSelectionUpdate: (editor) ->
            vm.updateTableSelectionState(editor)
            vm.syncRulerFromSelection()
            $scope.$applyAsync()
        })
        vm.templateEditorReady = true
        vm.updateTableSelectionState(vm.templateEditor)
        applyEditorLayoutStyles()
        scheduleInitialEditorRefresh()
        true
      catch e
        vm.templateEditorReady = false
        false

    initHeaderFooterEditors = ->
      initHeaderEditor()
      initFooterEditor()
      return

    initHeaderEditor = ->
      return true if vm.headerEditor?
      el = document.getElementById('fp_header_editor')
      return false unless el?

      try
        vm.headerEditor = createSpuTemplateEditor({
          element: el
          content: vm.pageHeaderContentJson
          placeholder: 'Digite o cabeçalho...'
          enablePagination: false
          editable: true
          includeFormControlClass: false
          editorClassName: 'fp-header-footer-editor form-control'
          maxContentHeightPx: vm.pageHeaderHeightPx
          onFocus: ->
            vm.activeContentEditor = 'header'
            vm.pageSectionEditorMode = 'header'
            refreshPageSectionOverlays()
            $scope.$applyAsync()
          onUpdate: (json) ->
            vm.pageHeaderContentJson = json
            vm.pageHeaderHtml = vm.headerEditor?.getHTML?() || ''
            syncTemplateLayoutMetadata()
            applyEditorLayoutStyles()
            $scope.$applyAsync()
        })
        vm.pageHeaderHtml = vm.headerEditor?.getHTML?() || ''
        applyEditorLayoutStyles()
        true
      catch e
        false

    initFooterEditor = ->
      return true if vm.footerEditor?
      el = document.getElementById('fp_footer_editor')
      return false unless el?

      try
        vm.footerEditor = createSpuTemplateEditor({
          element: el
          content: vm.pageFooterContentJson
          placeholder: 'Digite o rodapé...'
          enablePagination: false
          editable: true
          includeFormControlClass: false
          editorClassName: 'fp-header-footer-editor form-control'
          maxContentHeightPx: vm.pageFooterHeightPx
          onFocus: ->
            vm.activeContentEditor = 'footer'
            vm.pageSectionEditorMode = 'footer'
            refreshPageSectionOverlays()
            $scope.$applyAsync()
          onUpdate: (json) ->
            vm.pageFooterContentJson = json
            vm.pageFooterHtml = vm.footerEditor?.getHTML?() || ''
            syncTemplateLayoutMetadata()
            applyEditorLayoutStyles()
            $scope.$applyAsync()
        })
        vm.pageFooterHtml = vm.footerEditor?.getHTML?() || ''
        applyEditorLayoutStyles()
        true
      catch e
        false

    # METHODS VIEW MODEL
    vm.initFields = (initial) ->
      if initial? && initial.length > 0
        vm.fields =
          initial.map (f) ->
            f._optionsStr = (f.options || []).join(', ') if f.type == 'select'
            f.required    = (f.required == true || f.required == 'true')
            f
      initFieldTypeSelect2()
      return

    vm.initTemplate = (initialTemplateJson) ->
      vm.templateJson =
        if initialTemplateJson? && angular.isObject(initialTemplateJson) && initialTemplateJson.type == 'doc'
          initialTemplateJson
        else
          {type: 'doc', content: [{type: 'paragraph'}]}

      initialLayout = vm.templateJson.layout
      if angular.isObject(initialLayout)
        vm.showPageNumbers = !!initialLayout.show_page_numbers
        vm.pageNumberRightCm = safeFloat(initialLayout.page_number_right_cm, vm.defaultPageNumberRightCm)
        vm.pageNumberBottomCm = safeFloat(initialLayout.page_number_bottom_cm, vm.defaultPageNumberBottomCm)
        vm.pageMarginTopPx = clampMarginPx(initialLayout.margin_top_px, vm.defaultPageMarginTopPx, 'top')
        vm.pageMarginRightPx = clampMarginPx(initialLayout.margin_right_px, vm.defaultPageMarginRightPx, 'right')
        vm.pageMarginBottomPx = clampMarginPx(initialLayout.margin_bottom_px, vm.defaultPageMarginBottomPx, 'bottom')
        vm.pageMarginLeftPx = clampMarginPx(initialLayout.margin_left_px, vm.defaultPageMarginLeftPx, 'left')
        headerLayout = initialLayout.header
        footerLayout = initialLayout.footer
        if angular.isObject(headerLayout)
          vm.pageHeaderEnabled = !!headerLayout.enabled
          vm.pageHeaderHeightPx = clampSectionHeightPx(headerLayout.height_px, 'header')
          vm.pageHeaderHeightPx = vm.defaultHeaderHeightPx if vm.pageHeaderEnabled && vm.pageHeaderHeightPx <= 0
          vm.pageHeaderHeightPx = vm.defaultHeaderHeightPx if vm.pageHeaderEnabled && vm.pageHeaderHeightPx < vm.defaultHeaderHeightPx
          vm.pageHeaderContentJson = if angular.isObject(headerLayout.content_json) then headerLayout.content_json else {type: 'doc', content: [{type: 'paragraph'}]}
        if angular.isObject(footerLayout)
          vm.pageFooterEnabled = !!footerLayout.enabled
          vm.pageFooterHeightPx = clampSectionHeightPx(footerLayout.height_px, 'footer')
          vm.pageFooterHeightPx = vm.defaultFooterHeightPx if vm.pageFooterEnabled && vm.pageFooterHeightPx <= 0
          vm.pageFooterHeightPx = vm.defaultFooterHeightPx if vm.pageFooterEnabled && vm.pageFooterHeightPx < vm.defaultFooterHeightPx
          vm.pageFooterContentJson = if angular.isObject(footerLayout.content_json) then footerLayout.content_json else {type: 'doc', content: [{type: 'paragraph'}]}
      else
        vm.pageMarginTopPx = vm.defaultPageMarginTopPx
        vm.pageMarginRightPx = vm.defaultPageMarginRightPx
        vm.pageMarginBottomPx = vm.defaultPageMarginBottomPx
        vm.pageMarginLeftPx = vm.defaultPageMarginLeftPx
        vm.pageHeaderEnabled = false
        vm.pageFooterEnabled = false
        vm.pageNumberRightCm = vm.defaultPageNumberRightCm
        vm.pageNumberBottomCm = vm.defaultPageNumberBottomCm
        vm.pageHeaderHeightPx = vm.defaultHeaderHeightPx
        vm.pageFooterHeightPx = vm.defaultFooterHeightPx
        vm.pageHeaderContentJson = {type: 'doc', content: [{type: 'paragraph'}]}
        vm.pageFooterContentJson = {type: 'doc', content: [{type: 'paragraph'}]}

      updatePageLayoutVars()
      syncMarginCmFieldsFromPx()
      syncSectionHeightInputs()
      vm.templateJsonSerialized = JSON.stringify(vm.templateJson)
      syncTemplateLayoutMetadata()
      vm.rebuildFieldVariables()
      vm.validateTemplateVariables()
      return

    vm.canPasso1 = ->
      true

    vm.canPasso2 = ->
      return vm.form.evento && vm.canPasso1()

    vm.canPasso3 = ->
      return vm.form.tipo_id && vm.canPasso2()

    vm.canPasso4 = ->
      return vm.form.assunto_id && vm.canPasso3()

    vm.canSubmit = ->
      return false unless vm.form.evento && vm.form.tipo_id && vm.form.assunto_id
      return false unless vm.fields?.length > 0
      for f in vm.fields
        return false if !f.label || !f.type
        return false if !f.key
        return false if f.type == 'select' && (!f.options || f.options.length == 0)
      return false if vm.templateVariableInvalidKeys.length > 0
      return true

    vm.addField = ->
      vm.fields.push({label: '', key: '', type: 'text', required: false})
      vm.rebuildFieldVariables()
      initFieldTypeSelect2()
      return

    vm.removeField = (index) ->
      vm.fields.splice(index, 1)
      vm.rebuildFieldVariables()
      vm.validateTemplateVariables()
      initFieldTypeSelect2()
      return

    vm.moveFieldUp = (index) ->
      return if index <= 0
      atual = vm.fields[index]
      vm.fields[index] = vm.fields[index - 1]
      vm.fields[index - 1] = atual
      vm.rebuildFieldVariables()
      initFieldTypeSelect2()
      return

    vm.moveFieldDown = (index) ->
      return if index >= vm.fields.length - 1
      atual = vm.fields[index]
      vm.fields[index] = vm.fields[index + 1]
      vm.fields[index + 1] = atual
      vm.rebuildFieldVariables()
      initFieldTypeSelect2()
      return

    slugify = (value) ->
      return '' unless value?
      str = String(value)
      str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') if str.normalize?
      str.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '')

    vm.syncKeyFromLabel = (index) ->
      field = vm.fields[index]
      return unless field?
      base = slugify(field.label)
      base = 'campo' if base == ''
      candidate = base
      suffix = 2
      used = {}
      for f, i in vm.fields
        continue if i == index
        used[f.key] = true if f.key
      while used[candidate]
        candidate = "#{base}_#{suffix}"
        suffix += 1
      field.key = candidate
      vm.rebuildFieldVariables()
      vm.validateTemplateVariables()
      return

    vm.optionsToString = (field) ->
      (field.options || []).join(', ')

    vm.optionsFromString = (field) ->
      raw = field._optionsStr || ''
      field.options = raw.split(',').map((s) -> s.trim()).filter((s) -> s.length > 0)
      return

    vm.fieldsAsJson = ->
      cleaned =
        vm.fields.map (f) ->
          out = {label: f.label, key: f.key, type: f.type, required: !!f.required}
          out.options = f.options if f.type == 'select'
          out
      JSON.stringify({fields: cleaned})

    vm.rebuildFieldVariables = ->
      vm.fieldVariablesList =
        (vm.fields || [])
          .filter((f) -> f?.key)
          .map((f) -> {key: f.key, label: f.label || f.key, source: 'form_field'})
      return

    vm.availableVariables = ->
      vm.fieldVariablesList.concat(
        vm.PROCESSO_VARIABLES.map((v) -> {key: v.key, label: v.label, source: 'processo'})
      ).concat(
        vm.MANIFESTANTE_VARIABLES.map((v) -> {key: v.key, label: v.label, source: 'manifestante'})
      ).concat(
        vm.GENERAL_VARIABLES.map((v) -> {key: v.key, label: v.label, source: 'general'})
      )

    vm.insertVariable = (variable) ->
      initTemplateEditorWithRetry()
      insertSpuVariable(currentFormattingEditor(), variable)
      vm.variableMenuOpen = null
      return

    vm.syncRulerFromSelection = ->
      return unless vm.templateEditor?
      return if vm.rulerDragging?
      attrs = vm.templateEditor.getAttributes('paragraph')
      if !attrs? || Object.keys(attrs).length == 0
        attrs = vm.templateEditor.getAttributes('heading')
      indent = parseInt(attrs?.indent || 0, 10) || 0
      textIndent = parseInt(attrs?.textIndent || 0, 10) || 0
      vm.rulerLeftIndentPx = vm.rulerPaddingLeftPx + indent
      vm.rulerFirstLineIndentPx = vm.rulerPaddingLeftPx + indent + textIndent
      syncSliderElements()
      return

    vm.onLeftIndentSliderChange = ->
      return unless vm.templateEditor?
      vm.rulerLeftIndentPx = parseInt(vm.rulerLeftIndentPx || vm.rulerMinPx, 10) || vm.rulerMinPx
      x = clampRuler(vm.rulerLeftIndentPx)
      vm.rulerLeftIndentPx = x
      relativeIndent = x - vm.rulerPaddingLeftPx
      vm.templateEditor.chain().focus().setIndentPx(relativeIndent).run()

      textRelative = vm.rulerFirstLineIndentPx - vm.rulerLeftIndentPx
      vm.templateEditor.chain().focus().setTextIndentPx(textRelative).run()
      return

    vm.onFirstIndentSliderChange = ->
      return unless vm.templateEditor?
      vm.rulerFirstLineIndentPx = parseInt(vm.rulerFirstLineIndentPx || vm.rulerMinPx, 10) || vm.rulerMinPx
      x = clampRuler(vm.rulerFirstLineIndentPx)
      vm.rulerFirstLineIndentPx = x
      textRelative = x - vm.rulerLeftIndentPx
      vm.templateEditor.chain().focus().setTextIndentPx(textRelative).run()
      return

    clampRuler = (value) ->
      n = parseInt(value || 0, 10) || 0
      minX = vm.rulerMinPx
      maxX = vm.rulerMaxPx
      n = minX if n < minX
      n = maxX if n > maxX
      n

    eventClientX = (event) ->
      e = event?.originalEvent || event
      if e?.clientX?
        return e.clientX
      if e?.pageX?
        scrollX = window.pageXOffset || document.documentElement?.scrollLeft || document.body?.scrollLeft || 0
        return e.pageX - scrollX
      0

    vm.startRulerDrag = (kind, $event) ->
      return unless vm.templateEditor?
      vm.rulerDragging = kind
      $event.preventDefault()
      vm.onRulerMouseMove($event)
      vm._rulerMoveHandler = (event) ->
        vm.onRulerMouseMove(event)
        $scope.$applyAsync()
      vm._rulerUpHandler = ->
        vm.stopRulerDrag()
        $scope.$applyAsync()
      document.addEventListener('mousemove', vm._rulerMoveHandler)
      document.addEventListener('mouseup', vm._rulerUpHandler)
      return

    vm.startLeftRulerDrag = ($event) ->
      vm.startRulerDrag('left', $event)
      return

    vm.startFirstRulerDrag = ($event) ->
      vm.startRulerDrag('first', $event)
      return

    vm.onRulerMouseMove = ($event) ->
      return unless vm.rulerDragging?
      ruler = document.getElementById('fp_ruler')
      return unless ruler?
      rect = ruler.getBoundingClientRect()
      zoom = (parseInt(vm.editorZoom || 100, 10) || 100) / 100.0
      zoom = 1 if zoom <= 0
      pointerX = eventClientX($event)
      x = clampRuler((pointerX - rect.left) / zoom)

      if vm.rulerDragging == 'left'
        vm.rulerLeftIndentPx = x
        relativeIndent = x - vm.rulerPaddingLeftPx
        vm.templateEditor.chain().focus().setIndentPx(relativeIndent).run()
        textRelative = vm.rulerFirstLineIndentPx - vm.rulerLeftIndentPx
        vm.templateEditor.chain().focus().setTextIndentPx(textRelative).run()
      else if vm.rulerDragging == 'first'
        vm.rulerFirstLineIndentPx = x
        textRelative = x - vm.rulerLeftIndentPx
        vm.templateEditor.chain().focus().setTextIndentPx(textRelative).run()
      return

    vm.stopRulerDrag = ->
      vm.rulerDragging = null
      if vm._rulerMoveHandler?
        document.removeEventListener('mousemove', vm._rulerMoveHandler)
        vm._rulerMoveHandler = null
      if vm._rulerUpHandler?
        document.removeEventListener('mouseup', vm._rulerUpHandler)
        vm._rulerUpHandler = null
      return

    vm.rulerHandleStyle = (kind) ->
      leftPx = if kind == 'left' then vm.rulerLeftIndentPx else vm.rulerFirstLineIndentPx
      { left: "#{leftPx}px" }

    vm.toggleMark = (mark) ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().toggleMark(mark).run()
      return

    vm.toggleUnderline = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().toggleUnderline().run()
      return

    vm.togglePageNumbers = ->
      vm.showPageNumbers = !vm.showPageNumbers
      vm.pageNumberPickerOpen = !!vm.showPageNumbers
      applyEditorLayoutStyles()
      syncTemplateLayoutMetadata()
      return

    vm.applyPageNumberPositionSettings = ->
      vm.pageNumberRightCm = safeFloat(vm.pageNumberRightCm, vm.defaultPageNumberRightCm)
      vm.pageNumberBottomCm = safeFloat(vm.pageNumberBottomCm, vm.defaultPageNumberBottomCm)
      applyEditorLayoutStyles()
      syncTemplateLayoutMetadata()
      return

    vm.resetPageNumberPositionToDefault = ->
      vm.pageNumberRightCm = vm.defaultPageNumberRightCm
      vm.pageNumberBottomCm = vm.defaultPageNumberBottomCm
      applyEditorLayoutStyles()
      syncTemplateLayoutMetadata()
      return

    vm.toggleBulletList = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().toggleBulletList().run()
      return

    vm.toggleOrderedList = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().toggleOrderedList().run()
      return

    vm.toggleBlockquote = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().toggleBlockquote().run()
      return

    vm.toggleCodeBlock = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().toggleCodeBlock().run()
      return

    vm.toggleMarkCode = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().toggleCode().run()
      return

    vm.setHorizontalRule = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().setHorizontalRule().run()
      return

    vm.setHardBreak = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().setHardBreak().run()
      return

    vm.clearFormatting = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().unsetAllMarks().clearNodes().run()
      return

    vm.setTextAlign = (align) ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().setTextAlign(align).run()
      return

    vm.isTextAlignActive = (align) ->
      editor = currentFormattingEditor()
      return false unless editor?
      editor.isActive({textAlign: align})

    vm.setBlockType = ->
      editor = currentFormattingEditor()
      return unless editor?
      switch vm.selectedBlockType
        when 'h1' then editor.chain().focus().toggleHeading({level: 1}).run()
        when 'h2' then editor.chain().focus().toggleHeading({level: 2}).run()
        when 'h3' then editor.chain().focus().toggleHeading({level: 3}).run()
        else editor.chain().focus().setParagraph().run()
      return

    vm.setFontSize = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().setFontSize(vm.selectedFontSize).run()
      return

    vm.setFontColor = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().setColor(vm.selectedFontColor).run()
      return

    vm.selectToolbarGroup = (groupKey) ->
      vm.activeToolbarGroup = groupKey
      return

    vm.isToolbarGroupActive = (groupKey) ->
      vm.activeToolbarGroup == groupKey

    vm.increaseIndent = ->
      vm.pageMarginLeftPx = Math.min(220, (parseInt(vm.pageMarginLeftPx || 0, 10) || 0) + 10)
      updatePageLayoutVars()
      applyEditorLayoutStyles()
      refreshEditorPages()
      vm.syncRulerFromSelection()
      return

    vm.decreaseIndent = ->
      vm.pageMarginLeftPx = Math.max(20, (parseInt(vm.pageMarginLeftPx || 0, 10) || 0) - 10)
      updatePageLayoutVars()
      applyEditorLayoutStyles()
      refreshEditorPages()
      vm.syncRulerFromSelection()
      return

    vm.openTablePicker = ->
      vm.variableMenuOpen = null
      vm.pageNumberPickerOpen = false
      vm.tablePickerOpen = !vm.tablePickerOpen
      vm.marginEditorOpen = false if vm.tablePickerOpen
      vm.tableHoverRows = 0 unless vm.tablePickerOpen
      vm.tableHoverCols = 0 unless vm.tablePickerOpen
      return

    vm.toggleMarginEditor = ->
      vm.variableMenuOpen = null
      vm.pageNumberPickerOpen = false
      vm.marginEditorOpen = !vm.marginEditorOpen
      vm.tablePickerOpen = false if vm.marginEditorOpen
      syncMarginCmFieldsFromPx() if vm.marginEditorOpen
      return

    vm.activatePageSection = (section) ->
      vm.pageSectionEditorMode = section
      vm.activeContentEditor = if section == 'header' then 'header' else if section == 'footer' then 'footer' else 'main'
      vm.marginEditorOpen = false
      vm.pageNumberPickerOpen = false
      vm.variableMenuOpen = null
      vm.tablePickerOpen = false
      $timeout((->
        if section == 'header'
          refreshPageSectionOverlays()
          vm.headerEditor?.commands?.focus?()
        else if section == 'footer'
          refreshPageSectionOverlays()
          vm.footerEditor?.commands?.focus?()
      ), 0)
      return

    vm.focusHeaderSection = (pageNumber = 1) ->
      return unless vm.pageHeaderEnabled
      vm.activeHeaderPageNumber = Math.max(1, parseInt(pageNumber || 1, 10) || 1)
      vm.activatePageSection('header')
      $timeout((-> refreshPageSectionOverlays()), 0)
      return

    vm.focusFooterSection = (pageNumber = 1) ->
      return unless vm.pageFooterEnabled
      vm.activeFooterPageNumber = Math.max(1, parseInt(pageNumber || 1, 10) || 1)
      vm.activatePageSection('footer')
      $timeout((-> refreshPageSectionOverlays()), 0)
      return

    vm.openHeaderSection = ->
      vm.pageHeaderEnabled = true unless vm.pageHeaderEnabled
      vm.pageHeaderHeightPx = clampSectionHeightPx(vm.pageHeaderHeightPx, 'header')
      vm.pageHeaderHeightPx = vm.defaultHeaderHeightPx if vm.pageHeaderHeightPx <= 0
      vm.pageHeaderHeightPx = vm.defaultHeaderHeightPx if vm.pageHeaderHeightPx < vm.defaultHeaderHeightPx
      vm.activeHeaderPageNumber = 1 unless vm.activeHeaderPageNumber?
      syncSectionHeightInputs()
      applyEditorLayoutStyles()
      refreshEditorPages()
      syncTemplateLayoutMetadata()
      vm._pendingPageSectionFocus =
        section: 'header'
        pageNumber: vm.activeHeaderPageNumber
      return

    vm.disableHeaderSection = ->
      vm.pageHeaderEnabled = false
      vm.activeContentEditor = 'main' if vm.pageSectionEditorMode == 'header'
      vm.pageSectionEditorMode = null if vm.pageSectionEditorMode == 'header'
      refreshPageSectionOverlays()
      applyEditorLayoutStyles()
      refreshEditorPages()
      syncTemplateLayoutMetadata()
      return

    vm.toggleHeaderSection = ->
      if vm.pageHeaderEnabled
        vm.disableHeaderSection()
      else
        vm.openHeaderSection()
      return

    vm.openFooterSection = ->
      vm.pageFooterEnabled = true unless vm.pageFooterEnabled
      vm.pageFooterHeightPx = clampSectionHeightPx(vm.pageFooterHeightPx, 'footer')
      vm.pageFooterHeightPx = vm.defaultFooterHeightPx if vm.pageFooterHeightPx <= 0
      vm.pageFooterHeightPx = vm.defaultFooterHeightPx if vm.pageFooterHeightPx < vm.defaultFooterHeightPx
      vm.activeFooterPageNumber = 1 unless vm.activeFooterPageNumber?
      syncSectionHeightInputs()
      applyEditorLayoutStyles()
      refreshEditorPages()
      syncTemplateLayoutMetadata()
      vm._pendingPageSectionFocus =
        section: 'footer'
        pageNumber: vm.activeFooterPageNumber
      return

    vm.disableFooterSection = ->
      vm.pageFooterEnabled = false
      vm.activeContentEditor = 'main' if vm.pageSectionEditorMode == 'footer'
      vm.pageSectionEditorMode = null if vm.pageSectionEditorMode == 'footer'
      refreshPageSectionOverlays()
      applyEditorLayoutStyles()
      refreshEditorPages()
      syncTemplateLayoutMetadata()
      return

    vm.toggleFooterSection = ->
      if vm.pageFooterEnabled
        vm.disableFooterSection()
      else
        vm.openFooterSection()
      return

    vm.applyHeaderHeight = ->
      vm.pageHeaderHeightDraft = String(document.getElementById('fp_page_header_height_input')?.value || vm.pageHeaderHeightDraft || '')
      vm.pageHeaderHeightPx = clampSectionHeightPx(resolveSectionHeightInputPx('header'), 'header')
      syncSectionHeightInputs()
      applyEditorLayoutStyles()
      refreshEditorPages()
      syncTemplateLayoutMetadata()
      return

    vm.applyFooterHeight = ->
      vm.pageFooterHeightDraft = String(document.getElementById('fp_page_footer_height_input')?.value || vm.pageFooterHeightDraft || '')
      vm.pageFooterHeightPx = clampSectionHeightPx(resolveSectionHeightInputPx('footer'), 'footer')
      syncSectionHeightInputs()
      applyEditorLayoutStyles()
      refreshEditorPages()
      syncTemplateLayoutMetadata()
      return

    vm.toggleVariableMenu = (menuKey) ->
      vm.tablePickerOpen = false
      vm.marginEditorOpen = false
      vm.pageNumberPickerOpen = false
      vm.variableMenuOpen = if vm.variableMenuOpen == menuKey then null else menuKey
      return

    vm.isVariableMenuOpen = (menuKey) ->
      vm.variableMenuOpen == menuKey

    vm.applyMarginSettings = ->
      vm.pageMarginTopPx = clampMarginPx(Math.round(cmToPx(vm.pageMarginTopCm)), vm.defaultPageMarginTopPx, 'top')
      vm.pageMarginRightPx = clampMarginPx(Math.round(cmToPx(vm.pageMarginRightCm)), vm.defaultPageMarginRightPx, 'right')
      vm.pageMarginBottomPx = clampMarginPx(Math.round(cmToPx(vm.pageMarginBottomCm)), vm.defaultPageMarginBottomPx, 'bottom')
      vm.pageMarginLeftPx = clampMarginPx(Math.round(cmToPx(vm.pageMarginLeftCm)), vm.defaultPageMarginLeftPx, 'left')
      vm.pageHeaderHeightPx = clampSectionHeightPx(vm.pageHeaderHeightPx, 'header')
      vm.pageFooterHeightPx = clampSectionHeightPx(vm.pageFooterHeightPx, 'footer')
      syncSectionHeightInputs()
      updatePageLayoutVars()
      syncMarginCmFieldsFromPx()
      applyEditorLayoutStyles()
      refreshEditorPages()
      vm.syncRulerFromSelection()
      syncTemplateLayoutMetadata()
      return

    vm.resetMarginsToDefault = ->
      vm.pageMarginTopPx = vm.defaultPageMarginTopPx
      vm.pageMarginRightPx = vm.defaultPageMarginRightPx
      vm.pageMarginBottomPx = vm.defaultPageMarginBottomPx
      vm.pageMarginLeftPx = vm.defaultPageMarginLeftPx
      syncMarginCmFieldsFromPx()
      vm.applyMarginSettings()
      return

    vm.setActiveMarginSide = (side) ->
      vm.activeMarginSide = side
      return

    vm.clearActiveMarginSide = (side) ->
      vm.activeMarginSide = null if vm.activeMarginSide == side
      return

    vm.setTableHover = (rows, cols) ->
      vm.tableHoverRows = rows
      vm.tableHoverCols = cols
      return

    vm.updateTableSelectionState = (editor) ->
      vm.cursorInsideTable = !!editor?.isActive('table')
      vm.canMergeTableCells = false
      return unless vm.cursorInsideTable and editor? and editor.can?
      vm.canMergeTableCells = !!editor.can().mergeCells()
      return

    vm.insertTable = (rows = 3, cols = 3) ->
      return unless vm.templateEditor?
      vm.templateEditor.chain().focus().insertTable({rows: rows, cols: cols, withHeaderRow: true}).run()
      vm.tablePickerOpen = false
      vm.tableHoverRows = 0
      vm.tableHoverCols = 0
      return

    vm.addRowAfter = ->
      return unless vm.templateEditor?
      vm.templateEditor.chain().focus().addRowAfter().run()
      return

    vm.addColumnAfter = ->
      return unless vm.templateEditor?
      vm.templateEditor.chain().focus().addColumnAfter().run()
      return

    vm.deleteRow = ->
      return unless vm.templateEditor?
      vm.templateEditor.chain().focus().deleteRow().run()
      return

    vm.deleteColumn = ->
      return unless vm.templateEditor?
      vm.templateEditor.chain().focus().deleteColumn().run()
      return

    vm.deleteTable = ->
      return unless vm.templateEditor?
      vm.templateEditor.chain().focus().deleteTable().run()
      return

    vm.mergeTableCells = ->
      return unless vm.templateEditor?
      vm.templateEditor.chain().focus().mergeCells().run()
      return

    vm.triggerImageUpload = ->
      vm._pendingImageTargetEditor = vm.activeContentEditor || 'main'
      input = document.getElementById('fp_template_image_upload')
      input?.click()
      return

    buildTemplatePrintHtml = (editorRoot) ->
      clonedRoot = editorRoot.cloneNode(true)
      clonedRoot.removeAttribute('contenteditable')

      marginTop = parseInt(vm.pageMarginTopPx || 68, 10) || 68
      marginRight = parseInt(vm.pageMarginRightPx || 68, 10) || 68
      marginBottom = parseInt(vm.pageMarginBottomPx || 68, 10) || 68
      marginLeft = parseInt(vm.pageMarginLeftPx || 45, 10) || 45
      pageWidth = parseInt(vm.pageWidthPx || 794, 10) || 794
      pageHeight = parseInt(vm.pageHeightPx || 1123, 10) || 1123

      """
      <!DOCTYPE html>
      <html lang="pt-BR">
        <head>
          <meta charset="utf-8">
          <title>Impressao do Template</title>
          <style>
            * { box-sizing: border-box; }
            html, body {
              margin: 0;
              padding: 0;
              background: #ffffff;
              color: #1f2933;
              font-family: Arial, sans-serif;
            }
            body {
              padding: 24px 0;
            }
            .fp-print-root {
              width: #{pageWidth}px;
              margin: 0 auto;
            }
            .fp-template-editor {
              width: #{pageWidth}px;
              margin: 0 auto;
              border: 0 !important;
              background: #ffffff !important;
              box-shadow: none !important;
              overflow: visible !important;
            }
            .fp-template-editor:not(.rm-with-pagination) {
              padding: #{marginTop}px #{marginRight}px #{marginBottom}px #{marginLeft}px !important;
              min-height: #{pageHeight}px;
            }
            .fp-template-editor.rm-with-pagination,
            .fp-template-editor.rm-with-pagination .rm-page-break,
            .fp-template-editor.rm-with-pagination .rm-page-break > .page {
              background: #ffffff !important;
              box-shadow: none !important;
              border: 0 !important;
            }
            .fp-template-editor.rm-with-pagination .rm-pagination-gap,
            .fp-template-editor.rm-with-pagination .breaker {
              display: none !important;
            }
            .fp-template-editor p { margin: 0 0 0.5rem; }
            .fp-template-editor p:last-child { margin-bottom: 0; }
            .fp-template-editor td p,
            .fp-template-editor th p { margin: 0; }
            .fp-header-footer-editor-shell .fp-template-editor p { margin: 0 !important; }
            .fp-header-footer-editor-shell .fp-template-editor p:last-child { margin-bottom: 0 !important; }
            .fp-header-footer-editor-shell .fp-template-editor td p,
            .fp-header-footer-editor-shell .fp-template-editor th p { margin: 0 !important; }
            .fp-template-editor h1,
            .fp-template-editor h2,
            .fp-template-editor h3 {
              margin: 0.5rem 0 0.35rem;
              line-height: 1.25;
            }
            .fp-template-editor table {
              border-collapse: collapse;
              width: 100%;
              margin: 0.6rem 0;
            }
            .fp-template-editor th,
            .fp-template-editor td {
              border: 1px solid #7d8793;
              min-width: 36px;
              padding: 6px 8px;
            }
            .fp-template-editor code {
              font-size: 0.92em;
              font-family: "Courier New", monospace;
              background: #eef2f7;
              border: 1px solid #d5dde7;
              border-radius: 4px;
              padding: 0.06rem 0.28rem;
            }
            .fp-template-editor pre {
              margin: 0.55rem 0;
              padding: 0.65rem 0.75rem;
              border: 1px solid #d5dde7;
              border-radius: 6px;
              background: #f5f8fc;
              overflow: auto;
              white-space: pre-wrap;
              word-break: break-word;
            }
            .fp-template-editor pre code {
              display: block;
              background: transparent;
              border: 0;
              border-radius: 0;
              padding: 0;
            }
            .spu-template-variable-chip {
              display: inline-block;
              padding: 0.1rem 0.35rem;
              margin: 0 0.1rem;
              border-radius: 10px;
              background: #e8f3ff;
              border: 1px solid #b6daff;
              color: #0957a8;
              font-size: 0.85em;
              white-space: nowrap;
            }
            .spu-template-variable-chip-processo,
            .spu-template-variable-chip-manifestante,
            .spu-template-variable-chip-general {
              background: #e8f8ee;
              border-color: #b9e6c8;
              color: #207845;
            }
            @page {
              margin: 0;
            }
            @media print {
              body {
                padding: 0;
              }
            }
          </style>
        </head>
        <body>
          <div class="fp-print-root">#{clonedRoot.outerHTML}</div>
        </body>
      </html>
      """

    vm.printTemplate = ->
      editorRoot = document.getElementById('fp_template_editor')
      return unless editorRoot?

      printWindow = window.open('', '_blank', 'noopener,noreferrer,width=1100,height=900')
      return unless printWindow?

      printWindow.document.open()
      printWindow.document.write(buildTemplatePrintHtml(editorRoot))
      printWindow.document.close()
      printWindow.focus()

      triggerPrint = ->
        printWindow.print()
        printWindow.close()
        return

      if printWindow.document.readyState == 'complete'
        triggerPrint()
      else
        printWindow.onload = triggerPrint
      return

    vm.onImageSelected = (event) ->
      files = event?.target?.files
      return unless files? && files.length > 0
      file = files[0]
      reader = new FileReader()
      reader.onload = (e) ->
        src = e?.target?.result
        return unless src?
        section = currentImageTargetSection()
        editor = currentImageTargetEditor(section)
        return unless editor?

        maxHeightPx = if section == 'header' || section == 'footer' then 80 else null
        resizeImageIfNeeded(file, src, maxHeightPx).then((imageAttrs) ->
          paginationDebug('image:insert', {
            section: section
            editorActive: vm.activeContentEditor
            attrs: imageAttrs
          })
          editor.chain().focus().setImage(imageAttrs).run()
          ensureTrailingParagraphAfterImage(editor) if section == 'header' || section == 'footer'
          editor.chain().focus('end').run() if section == 'header' || section == 'footer'
          vm._pendingImageTargetEditor = 'main'
          $scope.$applyAsync()
        )
      reader.readAsDataURL(file)
      event.target.value = ''
      return

    vm.gerarPdfSemValores = ->
      token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      actionUrl = document.getElementById('fp_btn_gerar_pdf_sem_valores')?.dataset?.pdfUrl
      return unless actionUrl?

      form = document.createElement('form')
      form.method = 'POST'
      form.action = actionUrl
      form.target = '_blank'
      form.style.display = 'none'

      tokenInput = document.createElement('input')
      tokenInput.type = 'hidden'
      tokenInput.name = 'authenticity_token'
      tokenInput.value = token || ''
      form.appendChild(tokenInput)

      templateInput = document.createElement('input')
      templateInput.type = 'hidden'
      templateInput.name = 'template_json'
      templateInput.value = vm.templateJsonSerialized || JSON.stringify(vm.templateJson || {type: 'doc', content: [{type: 'paragraph'}]})
      form.appendChild(templateInput)

      document.body.appendChild(form)
      form.submit()
      form.remove()
      return

    vm.setParagraph = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().setParagraph().run()
      return

    vm.toggleHeading = (level) ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().toggleHeading({level: level}).run()
      return

    vm.undoEditor = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().undo().run()
      return

    vm.redoEditor = ->
      editor = currentFormattingEditor()
      return unless editor?
      editor.chain().focus().redo().run()
      return

    vm.isActiveEditor = (name, attrs = null) ->
      editor = currentFormattingEditor()
      return false unless editor?
      if angular.isObject(name)
        return editor.isActive(name)
      if attrs?
        editor.isActive(name, attrs)
      else
        editor.isActive(name)

    vm.zoomStyle = (zoom) ->
      {}

    vm.templateAsJson = ->
      vm.templateJsonSerialized

    vm.fieldKeySet = ->
      keys = {}
      for f in (vm.fields || [])
        continue unless f?.key
        keys[String(f.key).trim()] = true
      keys

    vm.processVariableKeySet = ->
      keys = {}
      for item in vm.PROCESSO_VARIABLES
        keys[item.key] = true
      keys

    vm.manifestanteVariableKeySet = ->
      keys = {}
      for item in vm.MANIFESTANTE_VARIABLES
        keys[item.key] = true
      keys

    vm.generalVariableKeySet = ->
      keys = {}
      for item in vm.GENERAL_VARIABLES
        keys[item.key] = true
      keys

    vm.variableLabelByKey = (key) ->
      for f in (vm.fields || [])
        return (f.label || key) if f?.key == key
      for p in vm.PROCESSO_VARIABLES
        return p.label if p.key == key
      for m in vm.MANIFESTANTE_VARIABLES
        return m.label if m.key == key
      for g in vm.GENERAL_VARIABLES
        return g.label if g.key == key
      key

    vm.validateTemplateVariables = ->
      used = extractVariableKeysFromTemplateJson(vm.templateJson || {})
      fieldKeys = Object.keys(vm.fieldKeySet())
      allowed = vm.fieldKeySet()
      processo = vm.processVariableKeySet()
      manifestante = vm.manifestanteVariableKeySet()
      general = vm.generalVariableKeySet()
      invalid = []
      for key in used
        invalid.push(key) unless allowed[key] || processo[key] || manifestante[key] || general[key]
      unused = []
      usedSet = {}
      usedSet[k] = true for k in used
      for fieldKey in fieldKeys
        unused.push(fieldKey) unless usedSet[fieldKey]
      vm.templateVariableInvalidKeys = invalid
      vm.templateUnusedFieldKeys = unused
      return

    $scope.$on '$destroy', ->
      vm.stopRulerDrag()
      if vm._refreshEditorPagesTimeout?
        $timeout.cancel(vm._refreshEditorPagesTimeout)
        vm._refreshEditorPagesTimeout = null
      if vm._editorResizeObserver?
        vm._editorResizeObserver.disconnect()
        vm._editorResizeObserver = null
      ruler = document.getElementById('fp_ruler')
      leftHandle = document.getElementById('fp_ruler_handle_left')
      firstHandle = document.getElementById('fp_ruler_handle_first')
      if ruler? && vm._rulerDownHandler?
        ruler.removeEventListener('mousedown', vm._rulerDownHandler)
      if leftHandle? && vm._rulerLeftDownHandler?
        leftHandle.removeEventListener('mousedown', vm._rulerLeftDownHandler)
      if firstHandle? && vm._rulerFirstDownHandler?
        firstHandle.removeEventListener('mousedown', vm._rulerFirstDownHandler)
      leftSlider = document.getElementById('fp_ruler_slider_left')
      firstSlider = document.getElementById('fp_ruler_slider_first')
      headerHeightInput = document.getElementById('fp_page_header_height_input')
      footerHeightInput = document.getElementById('fp_page_footer_height_input')
      if leftSlider? && vm._leftSliderInputHandler?
        leftSlider.removeEventListener('input', vm._leftSliderInputHandler)
      if firstSlider? && vm._firstSliderInputHandler?
        firstSlider.removeEventListener('input', vm._firstSliderInputHandler)
      if headerHeightInput? && vm._headerHeightInputHandler?
        headerHeightInput.removeEventListener('input', vm._headerHeightInputHandler)
        headerHeightInput.removeEventListener('change', vm._headerHeightInputHandler)
      if footerHeightInput? && vm._footerHeightInputHandler?
        footerHeightInput.removeEventListener('input', vm._footerHeightInputHandler)
        footerHeightInput.removeEventListener('change', vm._footerHeightInputHandler)
      vm._rulerDownHandler = null
      vm._rulerLeftDownHandler = null
      vm._rulerFirstDownHandler = null
      vm._leftSliderInputHandler = null
      vm._firstSliderInputHandler = null
      vm._headerHeightInputHandler = null
      vm._footerHeightInputHandler = null
      vm.templateEditor?.destroy()
      vm.headerEditor?.destroy()
      vm.footerEditor?.destroy()
      vm.templateEditor = null
      vm.headerEditor = null
      vm.footerEditor = null
      return

    # CALL INIT SETUP
    updatePageLayoutVars()
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'FormularioPersonalizadoNewEditController', FormularioPersonalizadoNewEditController

  # ANGULAR INJECT DEPENDENCIES
  FormularioPersonalizadoNewEditController.$inject = ['$http', '$scope', '$timeout']

  # END BLOCK SCRIPT
  return
